<template>
    <v-dialog v-model="show" max-width="1010" persistent no-click-animation>
        <div class="QCCampaignCreator">
            <div class="dialog-header">
                <div>{{ $f.tc('createQCCampaign') }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" ref="form" @submit="submit" spellcheck="false">
                <v-tabs slider-color="#fff" v-model="tabCreateQC">
                    <v-tab ripple>
                        <div style="font-size: 20px; margin-bottom: 4px">01</div>
                        <div style="text-transform: capitalize">{{ $f.tc('campaign') }}</div>
                    </v-tab>
                    <v-tab ripple :disabled="!qcCampaign">
                        <div style="font-size: 20px; margin-bottom: 4px">02</div>
                        <div style="text-transform: capitalize">{{ $f.tc('dataInput') }}</div>
                    </v-tab>
                    <v-tab ripple :disabled="!qcCampaign">
                        <div style="font-size: 20px; margin-bottom: 4px">03</div>
                        <div style="text-transform: capitalize">{{ $f.tc('criteria') }}</div>
                    </v-tab>
                    <v-tab ripple :disabled="!qcCampaign">
                        <div style="font-size: 20px; margin-bottom: 4px">04</div>
                        <div style="text-transform: capitalize">{{ $f.tc('criteriaPerSentences') }}</div>
                    </v-tab>
                    <v-tabs-items>
                        <v-tab-item key="history">
                            <NewQCStep1
                                ref="NewQCStep1"
                                @nextStep="nextStep"
                                :campaignList="callCampaigns"
                            ></NewQCStep1>
                        </v-tab-item>
                        <v-tab-item v-if="!(!qcCampaign)">
                            <NewQCStep2
                                ref="NewQCStep2"
                                @backStep="backStep"
                                @nextStep="nextStep"
                            ></NewQCStep2>
                        </v-tab-item>
                        <v-tab-item v-if="!(!qcCampaign)">
                            <NewQCStep3
                                ref="NewQCStep3"
                                @backStep="backStep"
                                @nextStep="nextStep"
                                @configCriteria="configCriteria"
                            ></NewQCStep3>
                        </v-tab-item>
                        <v-tab-item v-if="!(!qcCampaign)">
                            <NewQCStep4
                                ref="NewQCStep3"
                                @backStep="backStep"
                                @configCriteria="configCriteria"
                            ></NewQCStep4>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import CampaignService from "@/services/campaign.service";
import NewQCStep1 from "@/views/QualityControl/Form/NewQCStep1";
import NewQCStep2 from "@/views/QualityControl/Form/NewQCStep2";
import NewQCStep3 from "@/views/QualityControl/Form/NewQCStep3";
import NewQCStep4 from "@/views/QualityControl/Form/NewQCStep4.vue";
import {mapState} from "vuex";

export default {
    name: "QCCampaignCreator",
    components: {NewQCStep4, NewQCStep3, NewQCStep2, NewQCStep1},
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            criteria: null,
            tabCreateQC: 0,
            dataCollectionList: [],
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            callCampaigns: state => state.qccampaign.callCampaigns
        })
    },
    methods: {
        getCallCampaigns() {
            if (this.callCampaigns.length > 0) return
            this.$appService.showLoading()
            this.$store.dispatch(this.$actionTypes.qccampaign.UPDATE_CALL_CAMPAIGNS).finally(this.$appService.hideLoading)
        },
        open(item) {
            // create new qc campaign
            if (!item.id) {
                this.clearFormData()
            } else { // edit existing qc campaign
                this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, item)
                this.$store.dispatch(this.$actionTypes.qccampaign.DATA_INPUT_SUGGESTION, this.qcCampaign.id)
            }
            this.show = true
            this.getCallCampaigns()
        },
        close() {
            this.tabCreateQC = 1
            this.show = false
            this.$refs.NewQCStep1.file = null
            this.$refs.NewQCStep1.fileName = ''
            this.clearFormData()
        },
        clearFormData() {
            this.$refs.NewQCStep1?.clearForm()
            this.$refs.NewQCStep2?.clearForm()
            this.$refs.NewQCStep3?.clearForm()
            this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, null)
            this.$store.commit(this.$actionTypes.qccampaign.DATA_INPUT_SUGGESTION, null)
        },
        configCriteria(criteria) {
            this.criteria = criteria
        },
        nextStep() {
            if (this.tabCreateQC < 3) {
                this.tabCreateQC += 1
            }
        },
        backStep() {
            if (this.tabCreateQC > 0) {
                this.tabCreateQC -= 1
            }
        }
    }
}
</script>

<style scoped lang="scss">
.QCCampaignCreator {
    background: #FFFFFF;
    position: relative;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi", serif;
        font-size: 13px;
    }

    ::v-deep {
        .v-tabs__item--active {
            background: #25B570 !important;
        }

        .v-tabs__item {
            background: #E7EDF5;
            align-items: flex-start;
            flex-direction: column;
        }

        .v-tabs__bar {
            padding: 12px;
        }

        .v-tabs .v-tabs__bar .v-tabs__item {
            margin-right: 0 !important;
            border-radius: 0 !important;
        }

        .v-tabs__container {
            .v-tabs__div {
                margin-right: 10px;
                height: 70px;
                min-width: 239px !important;
                text-transform: none !important;
                font-weight: 400;
                max-width: 322px !important;

                &:last-child {
                    margin-right: 0 !important;
                }
            }
        }
    }
}

.btn-custom {
    margin-left: 6px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }

    textarea {
        padding: 10px;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;

        &::-webkit-scrollbar {
            width: 7px;
            height: 10px;
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }

    .v-window__container {
        height: auto !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .content-tab {
        max-height: calc(90vh - 200px);
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>
